import { getCountryName } from "../../../../../utils/utils";
import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, } from "../../../../common/summary-common/confirmationData";
import { updateMapWithFieldsPreserveAll } from "./updateMapWithFields";

export const defaultPersonalInformationOfTheInsured: Map<string, ConfirmationData> = new Map([
    ["c25db4af-ac2f-4539-8490-735c10f388df", { fontWeight: "bold", showBorder: true }],
    ["0020fdeb-7776-4959-9ff2-198c2469eb27", { fontWeight: "bold", showBorder: true }],
    ["9e8e4349-5f9a-43e7-a048-856955040966", { fontWeight: "bold", showBorder: true }],
    ["773e8c82-3c69-4745-8520-43ac32b1b030", { fontWeight: "bold", showBorder: true }],
    ["6fe7ea08-6360-4d02-8fe5-3da568536456", { fontWeight: "bold", showBorder: true }],
    ["84f4b5e2-a240-4405-839b-a35924df2fa8", { fontWeight: "bold", showBorder: true }],
    ["3c7a2e47-5fc0-4e95-bcbf-0ee61d64a73d", { fontWeight: "bold", showBorder: true }],
    ["a1c1f62e-326b-46f0-bb7d-33d436ca267d", { fontWeight: "bold", showBorder: true }],
    ["103a15f4-0d02-496a-bf0f-994ee9e4b945", { fontWeight: "bold", showBorder: true }],
    ["c6b9ce70-2cdb-461a-b263-6b4d04f6b705|ce33e4e7-1939-4a45-84b4-a5788c0c6aff", { fontWeight: "bold", showBorder: true }],
    ["7c4e50cc-4488-4bf6-9388-1f1485fb473e", { fontWeight: "bold", showBorder: true }],
    ["34379aab-6f0f-4c7d-8329-36eb870526c0", { fontWeight: "bold", showBorder: true }],
    ["a75a9b18-e3e9-4631-b638-ea28bdf76190", { fontWeight: "bold", showBorder: true }],
    ["cd229724-cb09-4e70-9759-3fcd22e70723", { fontWeight: "bold", showBorder: false }]
]);

export const updatePersonalInformationOfTheInsured = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);
    const qCountry = answersMap.get("ce33e4e7-1939-4a45-84b4-a5788c0c6aff");
    if (qCountry !== undefined) {
        qCountry.value = getCountryName(qCountry.value);
        answersMap.set("ce33e4e7-1939-4a45-84b4-a5788c0c6aff", qCountry);
    }

    return updateMapWithFieldsPreserveAll(mapToTupleArray(answersMap), cd);
}